export default "__VITE_ASSET__DKdwhQF___"